<template>
  <div id="setting-screen" class="mt-0">
    <v-tabs
      :value="currentTabIndex"
      @change="changeTab"
      background-color="transparent"
      class="bg-white mb-4 rounded"
    >
      <v-tab
        v-for="tabItem in tabs"
        :tabindex="tabItem.index"
        :key="tabItem.index"
        @click="loadRoute(tabItem.routeName)"
        >{{ tabItem.label }}</v-tab
      >
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      currentTabIndex: null,
      tabs: [
        {
          index: 0,
          label: this.$t("GENERAL_SETTING"),
          routeName: "generalSetting",
          roles: []
        },
        {
          index: 1,
          label: this.$t("PAYMENT_POLICY"),
          routeName: "listOfPayments",
          roles: ['PAYMENT_POLICY']
        },
        {
          index: 2,
          label: this.$t("CANCELATION_POLICY"),
          routeName: "listOfCancellations",
          roles: ['CANCELLATION_POLICY']
        },
        {
          index: 3,
          label: this.$t("_PAYGATE.PAYMENT_METHOD"),
          routeName: "paymentMethod",
          roles: ['PAYMENT_METHOD']
        },
        {
          index: 4,
          label: this.$t("WARNING_METHOD"),
          routeName: "warningMethod",
          roles: ['WARNING_METHOD']
        }
      ]
    };
  },
  created() {
    this.tabs = this.fnItemTab(this.tabs);
    switch (this.$route.name) {
      case "generalSetting":
        this.currentTabIndex = 0;
        break;
      case "editPaymentPolicy":
      case "listOfPayments":
        this.currentTabIndex = 1;
        break;
      case "editCancellationPolicy":
      case "listOfCancellations":
        this.currentTabIndex = 2;
        break;
      case "paymentMethod":
        this.currentTabIndex = 3;
        break;
      case "warningMethod":
        this.currentTabIndex = 4;
        break;
    }
  },
  watch: {
    $route(value) {
      switch (this.$route.name) {
        case "generalSetting":
          this.currentTabIndex = 0;
          break;
        case "editPaymentPolicy":
        case "listOfPayments":
          this.currentTabIndex = 1;
          break;
        case "editCancellationPolicy":
        case "listOfCancellations":
          this.currentTabIndex = 2;
          break;
        case "paymentMethod":
          this.currentTabIndex = 3;
          break;
        case "warningMethod":
          this.currentTabIndex = 4;
          break;
      }
    },
  },
  methods: {
    changeTab(tabIndex) {
      this.currentTabIndex = tabIndex;
    },
    loadRoute(routeName) {
      this.$router.push({ name: routeName });
    }
  }
};
</script>
